import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './assets/css/main.css'
import './index.css'

createRoot(document.getElementById("root")!).render(<App />);
